// src/scripts/audits/venueAuditConfigs/index.js

import ariasFreezeAudit from "./Arias-FreezeAudit";
import londonStoneStAlbansAudit from "./london-stone-st-albansAudit";
import londonStoneStainesAudit from "./london-stone-stainesAudit";
import londonStoneWokingAudit from "./london-stone-wokingAudit";
import oBarZooWatfordAudit from "./o-bar-zoo-watfordAudit";
import testingVenueAudit from "./testing-venueAudit";
import theDukeOfWellingtonAudit from "./the-duke-of-wellingtonAudit";

function normaliseVenueId(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/^the\s+/, "")
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export const auditConfigsByVenueId = {
  "Arias-Freeze": ariasFreezeAudit,
  "arias-freeze": ariasFreezeAudit,

  "london-stone-st-albans": londonStoneStAlbansAudit,
  "london-stone-staines": londonStoneStainesAudit,
  "london-stone-woking": londonStoneWokingAudit,

  "o-bar-zoo-watford": oBarZooWatfordAudit,
  "testing-venue": testingVenueAudit,
  "the-duke-of-wellington": theDukeOfWellingtonAudit,
};

export function getAuditConfigForVenue(venueId) {
  const raw = String(venueId || "").trim();

  if (auditConfigsByVenueId[raw]) {
    return auditConfigsByVenueId[raw];
  }

  const normalised = normaliseVenueId(raw);

  return auditConfigsByVenueId[normalised] || null;
}